var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInformationInfo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "information"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.15669 7.15606 0 16 0C24.8433 0 32 7.15606 32 16C32 24.8433 24.8439 32 16 32C7.15669 32 0 24.8439 0 16ZM2.5 16C2.5 23.4616 8.53794 29.5 16 29.5C23.4615 29.5 29.5 23.4621 29.5 16C29.5 8.53844 23.4621 2.5 16 2.5C8.53844 2.5 2.5 8.53794 2.5 16Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16 13.3965C15.3096 13.3965 14.75 13.9561 14.75 14.6465V22.696C14.75 23.3864 15.3096 23.946 16 23.946C16.6904 23.946 17.25 23.3864 17.25 22.696V14.6465C17.25 13.9561 16.6904 13.3965 16 13.3965Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16,
    cy: 10.1777,
    r: 1.6875,
    fill: "#4A4A4A"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInformationInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/informationInfo.bc5196df105a536b15965a61bd1d6b7d.svg";